import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import cn from 'classnames';
import { getTestIds } from '../../utils/TestIds';
import { ConditionalWrapper } from '../ConditionalWrapper';
import { useIntentBehavior } from '../IntentBehavior';
import { Tooltip } from '../Tooltip';
import styles from './IconButton.module.scss';
export const GetIconButtonTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            IconButtonTID: {
                IconButton: (testid)=>testid !== null && testid !== void 0 ? testid : '',
                TooltipContent: (testid)=>testid ? "".concat(testid, "-wrapper") : ''
            }
        }
    });
export const IconButton = /*#__PURE__*/ React.forwardRef(function IconButton(props, ref) {
    const { className, children, disabled, size = 'medium', skin = 'standard', noPadding, cursorDefault, intent, tooltip, bordered, preferIntentTooltip, testId } = props, rest = _object_without_properties(props, [
        "className",
        "children",
        "disabled",
        "size",
        "skin",
        "noPadding",
        "cursorDefault",
        "intent",
        "tooltip",
        "bordered",
        "preferIntentTooltip",
        "testId"
    ]);
    const { getDisabled, getTooltip } = useIntentBehavior();
    const disabledFromIntent = intent ? getDisabled(intent) : false;
    const tooltipFromIntent = intent ? getTooltip(intent) : null;
    const hasTooltip = !!(tooltip === null || tooltip === void 0 ? void 0 : tooltip.title) || !!tooltipFromIntent;
    const { IconButtonTID } = useMemo(()=>GetIconButtonTID(testId !== null && testId !== void 0 ? testId : ''), [
        testId
    ]);
    return /*#__PURE__*/ _jsx(ConditionalWrapper, {
        condition: hasTooltip,
        wrapper: (children)=>/*#__PURE__*/ _jsx(Tooltip, _object_spread_props(_object_spread({}, preferIntentTooltip && tooltipFromIntent ? {
                placement: 'top',
                title: tooltipFromIntent
            } : tooltip || {
                placement: 'top',
                title: tooltipFromIntent
            }), {
                children: /*#__PURE__*/ _jsx("div", {
                    className: cn(styles.wrapper, className),
                    "data-testid": IconButtonTID.TooltipContent(testId),
                    children: children
                })
            })),
        children: /*#__PURE__*/ _jsx("button", _object_spread_props(_object_spread({
            ref: ref,
            disabled: disabledFromIntent || disabled,
            className: cn(styles.root, styles["".concat(skin, "Skin")], styles["".concat(size, "Size")], {
                [styles.noPadding]: noPadding,
                [styles.cursorDefault]: cursorDefault,
                [styles.bordered]: bordered
            }, !hasTooltip && className)
        }, rest, testId != null ? {
            'data-testid': testId
        } : {}), {
            children: children
        }))
    });
});
